import QRCode from "react-qr-code";
import { BookOpen } from "lucide-react";

export default function QRWithLogo({ value, size = 200, fgColor = "#2C2623" }) {
  const badge = Math.round(size * 0.24);
  return (
    <div className="relative inline-block" style={{ width: size, height: size }}>
      <QRCode value={value} size={size} fgColor={fgColor} level="H" style={{ height: size, width: size }} />
      <span
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-white rounded-md border border-stone-200"
        style={{ width: badge, height: badge }}
      >
        <BookOpen style={{ width: badge * 0.62, height: badge * 0.62, color: "#8C3A27" }} />
      </span>
    </div>
  );
}
